"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
require("core-js/modules/esnext.string.replace-all.js");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRequest = exports.deleteRequest = exports.getResponse = exports.getRequest = exports.proxyApi = void 0;
var sha1_1 = __importDefault(require("sha1"));
var uuid4_1 = __importDefault(require("uuid4"));
var serialize_1 = require("near-api-js/lib/utils/serialize");
var utils_1 = require("../utils");
exports.proxyApi = "https://h4n.app";
var getRequest = function getRequest(id, signal) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res, _yield$res$json, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch("".concat(exports.proxyApi, "/").concat(id, "/request"), {
            signal: signal,
            headers: {
              "content-type": "application/json"
            },
            method: "GET"
          });
        case 2:
          res = _context.sent;
          if (!(res.ok === false)) {
            _context.next = 9;
            break;
          }
          _context.t0 = Error;
          _context.next = 7;
          return res.text();
        case 7:
          _context.t1 = _context.sent;
          throw (0, _context.t0)(_context.t1);
        case 9:
          _context.next = 11;
          return res.json();
        case 11:
          _yield$res$json = _context.sent;
          data = _yield$res$json.data;
          return _context.abrupt("return", JSON.parse((0, serialize_1.base_decode)(data).toString("utf8")));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
exports.getRequest = getRequest;
var getResponse = function getResponse(id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _a, _b, _c, _d, res, _yield$res$json2, data, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetch("".concat(exports.proxyApi, "/").concat(id, "/response"), {
            headers: {
              "content-type": "application/json"
            },
            method: "GET"
          });
        case 2:
          res = _context2.sent;
          if (!(res.ok === false)) {
            _context2.next = 9;
            break;
          }
          _context2.t0 = Error;
          _context2.next = 7;
          return res.text();
        case 7:
          _context2.t1 = _context2.sent;
          throw (0, _context2.t0)(_context2.t1);
        case 9:
          _context2.next = 11;
          return res.json();
        case 11:
          _yield$res$json2 = _context2.sent;
          data = _yield$res$json2.data;
          result = (_a = JSON.parse(data)) !== null && _a !== void 0 ? _a : {};
          return _context2.abrupt("return", {
            account_id: (_b = result.account_id) !== null && _b !== void 0 ? _b : "",
            payload: (_c = result.payload) !== null && _c !== void 0 ? _c : "",
            status: (_d = result.status) !== null && _d !== void 0 ? _d : -1
          });
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};
exports.getResponse = getResponse;
var deleteRequest = function deleteRequest(id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fetch("".concat(exports.proxyApi, "/").concat(id), {
            headers: {
              "content-type": "application/json"
            },
            method: "DELETE"
          });
        case 2:
          res = _context3.sent;
          if (!(res.ok === false)) {
            _context3.next = 9;
            break;
          }
          _context3.t0 = Error;
          _context3.next = 7;
          return res.text();
        case 7:
          _context3.t1 = _context3.sent;
          throw (0, _context3.t0)(_context3.t1);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};
exports.deleteRequest = deleteRequest;
var createRequest = function createRequest(request, signal) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var query, hashsum, id, urlsafe, res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          query = (0, serialize_1.base_encode)(JSON.stringify(Object.assign(Object.assign({}, request), {
            _id: (0, uuid4_1.default)()
          })));
          hashsum = (0, sha1_1.default)(query);
          id = Buffer.from(hashsum, "hex").toString("base64");
          urlsafe = id.replaceAll("/", "_").replaceAll("-", "+").slice(0, 13);
          _context4.next = 6;
          return fetch("".concat(exports.proxyApi, "/").concat(urlsafe, "/request"), {
            method: "POST",
            signal: signal,
            body: JSON.stringify({
              topic_id: (0, utils_1.getDeviceId)(),
              data: query
            }),
            headers: {
              "content-type": "application/json"
            }
          });
        case 6:
          res = _context4.sent;
          if (!(res.ok === false)) {
            _context4.next = 13;
            break;
          }
          _context4.t0 = Error;
          _context4.next = 11;
          return res.text();
        case 11:
          _context4.t1 = _context4.sent;
          throw (0, _context4.t0)(_context4.t1);
        case 13:
          return _context4.abrupt("return", urlsafe);
        case 14:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};
exports.createRequest = createRequest;